<template>
  <div class="sld_collect_index">
    <el-container class="message-box">
      <el-container v-if="currentSession">
        <el-header>
          <Header
            :session-name="currentSession.sessionName"
            :sub-session-name="currentSession.subSessionName"
            :session-type="currentSession.sessionType"
            :session-id="currentSession.sessionId"
          />
        </el-header>
        <el-main>
          <Main
            :messages="currentSession.messages"
            :session-type="currentSession.sessionType"
          />
        </el-main>
        <el-footer height="250px">
          <Footer @send="handleSend" :disabled="isLoading" />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { nanoid } from "nanoid";
import Header from './component/Header.vue';
import Footer from './component/Footer.vue';
import Main from './component/Main';
import { post , get } from '@/utils/request'
export default {
  components: {
    Header,
    Footer,
    Main
  },
  data() {
    return {
      currentSession: {
        sessionId: nanoid(),
        sessionType: 2,
        sessionName: 'Hello，我是你的私人选品助手小衍',
        subSessionName: '你选品时关心的问题，我在这里告诉你~',
        messages: []
      },
      eventSource: null
    }
  },
  computed: {
    isLoading() {
      console.log(this.currentSession.messages.some(msg => msg.state === 1))
      return this.currentSession.messages.some(msg => msg.state === 1)
    }
  },
  methods: {
    handleSend(content) {
      this.currentSession.messages.push({
        id: new Date().getTime(),
        role: "user",
        time: this.formatDate(new Date()),
        content,
        state: 2,
      });

      const assistantMsg = {
        id: new Date().getTime(),
        role: "assistant",
        time: this.formatDate(new Date()),
        content: "",
        state: 1,
      };
      this.currentSession.messages.push(assistantMsg);
      console.log('assistantMsg index', )
      const assistantMsgIndex = this.currentSession.messages.indexOf(assistantMsg)

      if (this.currentSession.sessionType === 2) {
        // 文生图
        const question = {
          clientId: this.currentSession.sessionId,
          content,
        };
        post('v3/ai/front/submitImgJob', question, 'json')
          .then(submitRes => {
            console.log("submitRes", submitRes);
            if (submitRes.state !== 200) {
              this.currentSession.messages[assistantMsgIndex].state = 3
              return
            }

            const intervalId = setInterval(() => {
              get('v3/ai/front/queryImgJob', { jobId: submitRes.data.jobId })
                .then(queryRes => {
                  console.log("queryRes", queryRes);
                  if (queryRes.state !== 200) {
                    clearInterval(intervalId);
                    if (this.currentSession.messages[assistantMsgIndex].state === 1) {
                      this.currentSession.messages[assistantMsgIndex].state = 3
                    }
                    return
                  }

                  if (queryRes.data.jobStatusCode !== "2") {
                    clearInterval(intervalId);

                    if (queryRes.data.jobStatusCode === "5") {
                      this.currentSession.messages[assistantMsgIndex].content = `<img src="${queryRes.data.resultImage[0]}" alt="${queryRes.data.revisedPrompt[0]}" width="600px" class="result-img" style="cursor: pointer;" /><br/><p style="width: 600px;margin-top: 10px;">${queryRes.data.revisedPrompt[0]}</p>`
                      this.currentSession.messages[assistantMsgIndex].state = 2
                    }
                  }
                })
                .catch((queryErr) => {
                  clearInterval(intervalId);
                  console.log('queryErr', queryErr)
                  if (this.currentSession.messages[assistantMsgIndex].state === 1) {
                    this.currentSession.messages[assistantMsgIndex].state = 3
                  }
                })
            }, 1000);
          })
          .catch((submitErr) => {
            console.log("submitErr", submitErr);
            this.currentSession.messages[assistantMsgIndex].state = 3
          });
      }
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var hour = ("0" + date.getHours()).slice(-2);
      var minute = ("0" + date.getMinutes()).slice(-2);

      return year + "-" + month + "-" + day + " " + hour + ":" + minute;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/member/index.scss';
@import '@/style/base.scss';

.message-box {
  border: 1px solid #e0e0e0;
  margin: 15px;
  border-radius: 5px;

  .el-container {
    .el-header {
      display: flex;
      align-items: center;
      background: #fff;
      border-start-start-radius: 5px;
      border-start-end-radius: 5px;
    }

    .el-main {
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
      overflow-y: hidden;
      padding: 0;
      background: #fff;
    }

    .el-footer {
      background: #fff;
      border-end-end-radius: 5px;
      border-end-start-radius: 5px;
    }
  }
}
</style>